/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import Header from "../../../components/common/layout/Header";
import useAxios from "../../../shared/hooks/use-axios";
import { url } from "../../../shared/utils/url";
import { useSelector } from "react-redux";
import Banner from "../../../components/passenger/line/Banner";
import Details from "../../../components/passenger/line/Details";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { useSitemap } from "../../../shared/hooks/use-sitemap";
import Canonical from "../../../components/common/layout/Canonical";

const Line = () => {
    const theme: any = useSelector((state: any) => state.ui.theme);
    const lang: string = useSelector((state: any) => state.ui.lang);
    const [search, setSearch] = useState<string>("")
    const [debouncedValue, setDebouncedValue] = useState<string>(search);
    const [view, setView] = useState<string>("card")
    const [tab, setTab] = useState<number>(0)
    const [sts, setSts] = useState<any[]>([])
    const [line, setLine] = useState<any>(null)
    const [loading, setLoading] = useState<boolean>(true)
    const [isError, setIsError] = useState<boolean>(false)
    const { t } = useTranslation('common');
    useSitemap();

    const getLine = async () => {
        try {
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.line_list}`);

            if (res && res?.status === 200) {
                res?.data?.length > 0 && setLine(res?.data?.[0])
            }
        } catch (error) {
            console.error("error while feching line list", error);
        }
    };

    const getSt = async () => {
        try {
            setLoading(true)
            setIsError(false)
            if (!!debouncedValue) {
                const res: any = await useAxios.post(`/${(!!lang ? lang : "en") + url.search_by_facility_station}`, {
                    "search_keyword": debouncedValue
                });

                if (res && res.status === 200) {
                    setSts(res?.data?.data)
                    setLoading(false)
                }
            } else {
                const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url.search_by_facility_station}`);

                if (res && res.status === 200) {
                    setSts(res?.data?.data)
                    setLoading(false)
                }
            }
        } catch (error) {
            setIsError(true)
            setLoading(false)
            console.error("error while fetching station", error);
        }
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedValue(search);
        }, 500);

        return () => clearTimeout(timer);
    }, [search]);

    useEffect(() => {
        !!lang && getSt();
    }, [lang, debouncedValue])

    useEffect(() => {
        !!lang && getLine();
    }, [lang])

    return (
        <>
            <Canonical />
            <Helmet>
                <title>{t("seo_friendly.line.title")}</title>
                <meta name="description" content={t("seo_friendly.line.desc")} />
            </Helmet>
            <div className="w-full h-full bg-white dark:bg-bgDarkDull">
                <div className="w-full relative h-[360px] xsm:h-[300px] xlsm:h-[305px] msm:h-[330px] xlx:h-[375px]">
                    <img src={theme === "dark" ? require("../../../assets/images/dark-line-bg.png") : require("../../../assets/images/line-bg.png")} alt="line-bg" className="w-full h-full object-cover" />
                    <div className="absolute top-0 left-0 right-0 w-full">
                        <Header type="passenger" />
                    </div>
                    <Banner line={line} sts={sts} />
                </div>

                <div className="w-full h-full min-h-[450px]" id="home">
                    <Details sts={sts} search={search} setSearch={setSearch} setView={setView} view={view} setTab={setTab} tab={tab} line={line} loading={loading} isError={isError} />
                </div>
            </div>
        </>
    );
};

export default Line;